import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import _ from 'lodash';
import AppActions from '../../app/app_actions';
import * as agui from 'arm-gui/dist/controls';
import { Utils, UiUtils, NumberFormatter, DateFormatter, i18n, isAuth } from 'arm-common';
import { isNullOrUndefined } from 'util';
import LineaCard from './lineaCard.jsx';
import ConfirmModalDeleteV4 from '../shared/confirmModalDeleteV4.jsx'
import ProdottoActions from './prodotto_actions';
import FondiActions from '../fondi/fondi_action'


class ListaLinea extends React.Component {

    constructor(props) {
        super(props);
        this.componentName = '[ListaLinea.jsx] ';
        this.state = {
            idLineaDaEliminare: null,
            validation: new Map()
        }
        this.onClickEliminaLinea = this.onClickEliminaLinea.bind(this);
        this.onClickModificaLinea = this.onClickModificaLinea.bind(this);
        this.onClickAnnullaModifica = this.onClickAnnullaModifica.bind(this);
        this.onClickSalvaLinea = this.onClickSalvaLinea.bind(this);
        this.onClickNuovoLineaButton = this.onClickNuovoLineaButton.bind(this);
        this.showPopUP = this.showPopUP.bind(this);
        this.returnToPath = this.returnToPath.bind(this);
        this.validateForm = this.validateForm.bind(this);
    }

    componentDidMount() {
        console.log(this.componentName + ' componentDidMount');
        let prodottoCmpPojo = this.props.prodotto.prodottoCmpPojo;

        if (prodottoCmpPojo) {
            let idCompagnia = prodottoCmpPojo.prodottoCmp.idCompagnia
            if (idCompagnia) {
                this.props.getListaFondiOfCompagnia(idCompagnia);
            }

        }
    }

    componentWillReceiveProps(nextProps) {
        console.log(this.componentName + ' componentWillReceiveProps');

        if (nextProps.prodotto.prodottoCmpPojo && nextProps.prodotto.prodottoCmpPojo !== this.props.prodotto.prodottoCmpPojo) {
            let idCompagnia = nextProps.prodotto.prodottoCmpPojo.prodottoCmp.idCompagnia;
            if (idCompagnia) {
                this.props.getListaFondiOfCompagnia(idCompagnia);
            }
        }
    }

    //imposta il campo disabled a false per l'linea index della lista
    onClickModificaLinea(event) {
        console.log(this.componentName + ' onClickModificaLinea');
        if (isNullOrUndefined(event) || isNullOrUndefined(event.currentTarget) || isNullOrUndefined(event.currentTarget.id)) {
            return
        }
        let indexLinea = event.currentTarget.id;
        let linea = this.props.listProdottoLinea[indexLinea];
        if (linea) {
            this.props.handleChangeEditLinea(indexLinea, "editable", true)
            // let loc = this.props.listComune.find(com => com.comDenominazione === linea.inLoc);
            // if (!isNullOrUndefined(loc)) {
            //     this.props.getProvinciaByComCodIstat(loc.comCodIstat).then(
            //         resolve => {
            //             this.props.getListCapByComCodIstat(loc.comCodIstat)
            //             this.forceUpdate();
            //         }
            //     )
            // }
            // this.forceUpdate();
        }
    }

    //imposta il campo disabled a true per l'linea index della lista
    onClickAnnullaModifica(event) {
        console.log(this.componentName + ' onClickAnnullaModifica');
        if (isNullOrUndefined(event) || isNullOrUndefined(event.currentTarget) || isNullOrUndefined(event.currentTarget.id)) {
            return
        }
        let indexLinea = event.currentTarget.id;
        this.props.handleChangeEditLinea(indexLinea, "editable", false).then(
            resolve => {
                console.log(this.componentName + 'after delete linea, reload Linea ');
                this.setState({ validation: new Map() });
                //l'idProdotto è sempre lo stesso su tutti gli Linea quindi prendo il primo
                this.props.getLineProdotto(this.props.prodotto.id);
            }, reject => {
                console.log(this.componentName + ' deleteLinea KO');
            });
    }

    onClickEliminaLinea(event) {
        console.log(this.componentName + ' onClickEliminaLinea');
        // if (isNullOrUndefined(event) || isNullOrUndefined(event.currentTarget) || isNullOrUndefined(event.currentTarget.id)) {
        //     return
        // }
        this.props.showPopUP(false);
        let idLinea = this.state.idLineaDaEliminare;
        this.props.deleteLinea(idLinea).then(
            resolve => {
                console.log(this.componentName + 'after delete linea, reload Linea list');
                $('html, body').animate({ scrollTop: 0 }, 1000);
                //l'idProdotto è sempre lo stesso su tutti gli Linea quindi prendo il primo
                this.props.getLineProdotto(this.props.prodotto.id);
            }, reject => {
                console.log(this.componentName + ' deleteLinea KO');
                $('html, body').animate({ scrollTop: 0 }, 1000);
            });
    }

    onClickSalvaLinea(event) {
        console.log(this.componentName + ' onClickSalvaLinea');
        if (isNullOrUndefined(event) || isNullOrUndefined(event.currentTarget) || isNullOrUndefined(event.currentTarget.id)) {
            return
        }
        let indexLinea = event.currentTarget.id;
        if (this.validateForm(indexLinea)) {
            this.props.salvaLinea(indexLinea).then(
                resolve => {
                    console.log(this.componentName + 'after delete linea, reload Linea ');
                    this.props.getLineProdotto(this.props.prodotto.id);
                }, reject => {
                    console.log(this.componentName + ' salvaLinea KO');
                    $('html, body').animate({ scrollTop: 0 }, 1000);
                    this.props.handleChangeEditLinea(indexLinea, "editable", true);
                });
        }
    }

    onClickNuovoLineaButton() {
        console.log(this.componentName + ' onClickNuovoLineaButton');
        // Creo la struttura per consintire il sentimento di un nuovo oggetto linea
        this.props.creaNuovoLinea().then(
            resolve => {
                // $("html, body").animate({ scrollTop: $(document).height() - $(window).height() - 10 });

                let listProdottoLinea = this.props.listProdottoLinea;
                if (listProdottoLinea) {
                    let firstKey = listProdottoLinea.length - 1;
                    $('html, body').animate({
                        scrollTop: $("#linea" + firstKey).offset().top - 70
                    }, 1000);
                }
            }
        )
    }

    showPopUP(e) {
        console.log(this.componentName + ' showPopUP');

        let idLineaDaEliminare;
        if (e !== undefined && e !== null) {
            idLineaDaEliminare = e.currentTarget.id;
        }
        this.setState({ idLineaDaEliminare: idLineaDaEliminare })

        this.props.showPopUP(!this.props.showPopUp);
    }

    returnToPath() {
        console.log(this.componentName + ' returnToPath');
        let url = this.props.pathToReturn;
        this.props.history.push({ pathname: url });
    }

    validateForm(indexLinea) {

        let validation = new Map();
        let required = ['linNome', 'linInizioValidita', 'linDescrizione'];
        let linea = this.props.listProdottoLinea[indexLinea];
        if (linea) {
            for (let i = 0; i < required.length; i++) {
                if (linea[required[i]] === undefined || linea[required[i]] === '' || linea[required[i]] === null) {
                    validation.set(required[i] + indexLinea, i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));
                }
            }
        }

        if (linea.linValMinPercentuale && linea.linValMinPercentuale !== "") {
            if (linea.linValMinPercentuale > 100) {
                validation.set("linValMinPercentuale" + indexLinea, i18n('ARM_CORE_PRODUCT.SHARED.VALORE_MAX_ALLOWED', 'valore massima permessa:') + "100");
            }
        }

        if (linea.linValMinPercentuale && linea.linValMaxPecentuale &&
            Number(linea.linValMaxPecentuale) < Number(linea.linValMinPercentuale)) {
            validation.set("linValMaxPecentuale" + indexLinea, i18n('ARM_CORE_PRODUCT.SHARED.VALORE_MINORE_DA_MINIMA', '% massima minore della % mininima'));
        }

        if (linea.linValMaxPecentuale && linea.linValMaxPecentuale !== "") {
            if (linea.linValMaxPecentuale > 100) {
                validation.set("linValMaxPecentuale" + indexLinea, i18n('ARM_CORE_PRODUCT.SHARED.VALORE_MAX_ALLOWED', 'valore massima permessa:') + "100");
            }
        }

        if (linea.percMinFondo && linea.percMaxFondo &&
            Number(linea.percMaxFondo) < Number(linea.percMinFondo)) {
            validation.set("percMaxFondo" + indexLinea, i18n('ARM_CORE_PRODUCT.SHARED.VALORE_MINORE_DA_MINIMA', '% massima minore della % mininima'));
        }



        if (linea.percMinFondo && linea.percMinFondo !== "") {
            if (linea.percMinFondo > 100) {
                validation.set("percMinFondo" + indexLinea, i18n('ARM_CORE_PRODUCT.SHARED.VALORE_MAX_ALLOWED', 'valore massima permessa:') + "100");
            }
        }


        if (linea.percMaxFondo && linea.percMaxFondo !== "") {
            if (linea.percMaxFondo > 100) {
                validation.set("percMaxFondo" + indexLinea, i18n('ARM_CORE_PRODUCT.SHARED.VALORE_MAX_ALLOWED', 'valore massima permessa:') + "100");
            }
        }






        if (linea.linDettaglioSottostanti && linea.linMinSottostanti && linea.linMaxSottostanti &&
            linea.linMaxSottostanti < linea.linMinSottostanti) {
            validation.set("linMaxSottostanti" + indexLinea, i18n('ARM_CORE_PRODUCT.SHARED.VALORE_MINORE_DA_SOTTOSTANTI_MIN', 'Min sottostanti maggiore di max sottostanti'));
        }


        this.setState({ validation: validation })
        if (validation.size === 0) {
            return true;
        }
        return false;
    }

    render() {
        console.log(this.componentName + "render");
        // if (isNullOrUndefined(this.props.listProdottoLinea)) {
        // }
        let listProdottoLinea = this.props.listProdottoLinea;

        return (
            <agui.aCardV4>
                <agui.aCardV4Header>
                    <agui.aButton onClick={this.onClickNuovoLineaButton} className="btn btn-primary float-right" icon="fas fa-plus" > {i18n('ARM_CORE_PRODUCT.SHARED.NUOVO', 'Nuovo')} </agui.aButton>
                    < div className='d-flex flex-row ' >
                        {/* <agui.aButton onClick={this.returnToPath} className="btn btn-primary p-2" title={i18n('ARM_CORE_PRODUCT.SHARED', "Indietro")} icon="fas fa-angle-left" /> */}

                        <h3 className="p-2" >{i18n('ARM_CORE_PRODUCT.CLIENTS.CONTRAENTE.Linea', 'Linea')} </h3>
                    </ div>
                </agui.aCardV4Header>

                <agui.aCardV4Body>
                    <div className="row mt-3">
                        {
                            //dalla lista degli Linea presento a videso solo quello principale
                            listProdottoLinea && listProdottoLinea.map((linea, index) =>
                                <div key={"mainDiv" + index} id={"linea" + index} className="col-12 col-lg-12 col-md-12 col-sm-12">
                                    <LineaCard
                                        key={"linea" + index}
                                        linea={linea}
                                        isListaToEditButton={false}
                                        disabled={!linea.editable}
                                        index={index}
                                        validateForm={this.validateForm}
                                        validation={this.state.validation}
                                        fondiList={this.props.fondiList}
                                        titleCard={linea.idProdottoLinea ? "ID: " + linea.idProdottoLinea + " - " + i18n('ARM_CORE_PRODUCT.PRODOTTO.LINEA', 'Nome Linea') + ": " + (linea.linNome ? linea.linNome : "") : i18n('ARM_CORE_PRODUCT.PRODOTTO.NUOVA_LINEA', 'Creazione Nuova Linea')}
                                        onClickModificaLinea={this.onClickModificaLinea}
                                        onClickEliminaLinea={this.showPopUP}
                                        onClickAnnullaModifica={this.onClickAnnullaModifica}
                                        onClickSalvaLinea={this.onClickSalvaLinea} 
                                        downloadDocument={this.props.downloadDocument}/>
                                </div>
                            )
                        }
                        <ConfirmModalDeleteV4
                            show={this.props.showPopUp}
                            testoTitle={i18n('ARM_CORE_PRODUCT.PRODOTTO.ELIMINA.LINEA', 'Confermi di voler Eliminare? ')}
                            deleteOnClick={this.onClickEliminaLinea}
                            onClose={this.showPopUP} />
                    </div>
                </agui.aCardV4Body>
            </agui.aCardV4>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setPathNameToReturn(path) {
            return dispatch(AppActions.setPathNemeToReturn(path));
        },

        handleChangeLinea(index, id, value) {
            return dispatch(ProdottoActions.handleChangeLinea(index, id, value));
        },

        deleteLinea(idLinea) {
            return dispatch(ProdottoActions.deleteLinea(idLinea));
        },

        getLineProdotto(idProdotto) {
            return dispatch(ProdottoActions.getLineProdotto(idProdotto));
        },

        handleChangeEditLinea(index, isEditable) {
            return dispatch(ProdottoActions.handleChangeEditLinea(index, isEditable));
        },

        salvaLinea(indexLinea) {
            return dispatch(ProdottoActions.salvaLinea(indexLinea));
        },

        creaNuovoLinea() {
            return dispatch(ProdottoActions.creaNuovoLinea());
        },

        showPopUP(isShow) {
            return dispatch(AppActions.showPopUp(isShow))
        },

        handleChangeEditLinea(index, parametro, value) {
            return dispatch(ProdottoActions.handleChangeEditLinea(index, parametro, value));
        },

        getListaFondiOfCompagnia(idCompagnia) {
            return dispatch(ProdottoActions.getListaFondiOfCompagnia(idCompagnia));
        }


    }
};

function mapStateToProps(state) {
    return {
        showPopUp: state.app.showPopUp,
        fondiList: state.prodotto.listFondiProdotto,
        prodotto: state.prodotto.detailsProdotto,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ListaLinea);
